import { useEffect, useState, useRef } from "react";

// Loads HTML from /content/<file> (an editable file in public_html) at runtime.
// Lets non-developers edit page text directly in cPanel with no rebuild.
export const EditableContent = ({ file, fallback = "", className = "", executeScripts = false }) => {
  const [html, setHtml] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    let alive = true;
    fetch(`/content/${file}?t=${Date.now()}`)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error("missing"))))
      .then((t) => { if (alive) setHtml(t); })
      .catch(() => { if (alive) setHtml(fallback); });
    return () => { alive = false; };
  }, [file, fallback]);

  useEffect(() => {
    if (executeScripts && ref.current && html) {
      ref.current.querySelectorAll("script").forEach((old) => {
        const s = document.createElement("script");
        [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
        s.text = old.textContent;
        old.replaceWith(s);
      });
    }
  }, [html, executeScripts]);

  if (html === null) return null;
  return <div ref={ref} className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};
